import { useTranslation } from 'react-i18next';

export default function ConfirmDialog({ message, onConfirm, onCancel }: {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(10,10,25,0.92)' }}>
      <div className="bg-gray-900 border border-gray-600 rounded-xl w-full max-w-sm overflow-hidden">
        <div className="p-6 space-y-6">
          <p className="text-white font-bold text-lg text-center">{message}</p>
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 min-h-[3.5rem] bg-gray-700 hover:bg-gray-600 active:bg-gray-500 text-white font-bold text-lg rounded-lg"
            >
              {t('confirm.no')}
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 min-h-[3.5rem] bg-blue-600 hover:bg-blue-500 active:bg-blue-400 text-white font-bold text-lg rounded-lg"
            >
              {t('confirm.yes')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
